import { Carousel } from "primereact/carousel";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";

const ProductImageCarousel = (props) => {
  const [selectedThumbnailIndex, setSelectedThumbnailIndex] = useState(0);

  useEffect(() => {
    if (selectedThumbnailIndex >= props.items.length) {
      setSelectedThumbnailIndex(0);
    }
  }, [selectedThumbnailIndex]);

  const { items } = props;

  const itemTemplate = (item) => {
    return (
      <Image
        className="w-full"
        src={item.image}
        alt={item.alt}
        preview
        pt={{
          image: {
            className:
              "w-full h-[calc(4/5*100vw)] sm:w-[85vw] md:w-[800px] sm:h-[calc(4/5*85vw)] md:h-[calc(4/5*800px)] object-cover",
            // className: "w-full h-[calc(9/16*100vw)] object-cover",
          },
        }}
      />
    );
  };

  const ThumbnailTemplate = ({ item, selected, index }) => {
    return (
      <img
        className={`w-[4rem] h-[calc(4/5*4rem)] sm:w-[7rem] sm:h-[calc(4/5*7rem)] object-cover ${
          selected ? "" : "opacity-40"
        }`}
        // className={`w-[5rem] h-[calc(9/16*5rem)] object-cover ${
        //   selected ? "" : "opacity-40"
        // }`}
        src={item.image}
        alt={item.alt}
        onClick={() => setSelectedThumbnailIndex(index)}
      />
    );
  };

  return (
    <div className="flex flex-col sm:flex-row justify-start items-start w-full bg-slate-900 ">
      <Carousel
        className="w-full"
        value={items}
        numVisible={1}
        numScroll={1}
        itemTemplate={itemTemplate}
        // autoplayInterval={5000}
        showIndicators={false}
        showNavigators={false}
        page={selectedThumbnailIndex}
        onPageChange={(e) => {
          setSelectedThumbnailIndex(e.page);
        }}
      />
      <div className="flex flex-row sm:flex-col sm:gap-y-1 justify-center items-start bg-slate-900 w-full sm:w-auto pt-2 pb-3 px-2 overflow-x-auto gap-x-1">
        {items.map((item, index) => (
          <ThumbnailTemplate
            key={`thumbnail-${item.alt}`}
            item={item}
            selected={selectedThumbnailIndex === index}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductImageCarousel;
